/**
 * @generated SignedSource<<cb55e1dffe19b35d4fe3b2dab718ef43>>
 * @relayHash 85b6dc7a255d6f408393e487cd7be8aa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bf6d1d390e3bf3b7bb2181c7df0845ecf1a0c15976fcc736291aa5aead0e7ed8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainIssueAggQuery } from './mainIssueAggQuery.graphql';

const node: PreloadableConcreteRequest<mainIssueAggQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "bf6d1d390e3bf3b7bb2181c7df0845ecf1a0c15976fcc736291aa5aead0e7ed8",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "jira",
            "issueByKey",
            "attachments"
          ]
        }
      ]
    },
    "name": "mainIssueAggQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
